import { RouteConfig } from 'vue-router';
import dataCollection from "./dataCollection"
import govInfo from "@/router/government/govInfo";
import cockpit from '@/router/government/cockpit';
import systemSettings from '@/router/government/systemSettings';

const BASE_PATH = 'views/government';
const government: Array<RouteConfig> = [
    {
        path: 'gov',
        name: 'government',
        redirect: { name: 'dataCollection' },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            ...dataCollection,
            ...govInfo,
            ...cockpit,
            ...systemSettings
        ],
    },
];
export default government;